import { apiClient } from '@/services/api';
import type { Reminder } from '@/types/referral';

export const remindersService = {
  /**
   * POST /api/v1/reminders — log that the iOS Messages composer was opened
   * addressed to this referral.
   *
   * The column is `messages_opened_at`, not `sent_at`: iOS never tells us
   * whether the user pressed Send or Cancel after the composer opens, so
   * "we opened a composer for this person" is the strongest claim we can make.
   *
   * Keyed on the referral, never the referral link. The nudge feed's
   * `referral_link_id` is the attribution link (often null, and shared across
   * everyone who used one generic link) — logging against it would make a
   * contact's "Last reminded" caption report texts that were never sent to
   * them.
   */
  // Returns null rather than throwing on an empty/non-JSON 2xx: apiClient
  // hands back undefined on a 204 and null on any 2xx that isn't JSON, and
  // destructuring either would turn a *successful* log into a TypeError.
  async logNudge(referralId: number): Promise<Reminder | null> {
    const body = await apiClient.post<{ reminder: Reminder } | null>(
      '/api/v1/reminders',
      { referral_id: referralId },
    );
    return body?.reminder ?? null;
  },
};
